export class RequestFilter {
    status?: number;
    userId?: number;
    type?: number;

    constructor(status?: number, userId?: number, type?: number) {
        this.status = status;
        this.userId = userId;
        this.type = type
    }
}